import { render, staticRenderFns } from "./AppErrorsNotification.vue?vue&type=template&id=63001f5a&scoped=true&"
import script from "./AppErrorsNotification.vue?vue&type=script&lang=js&"
export * from "./AppErrorsNotification.vue?vue&type=script&lang=js&"
import style0 from "./AppErrorsNotification.vue?vue&type=style&index=0&id=63001f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63001f5a",
  null
  
)

export default component.exports